import { Div } from '@codesuma/baseline'
import style from './index.module.css'

// The chevron Papa List and Liu Cards both use for going back: two short bars
// rotated into a '›', drawn in currentColor so it takes the page's ink. The app
// is RTL, so it points to the right — the direction the reader came from.
export const BackIcon = () => {
    const base = Div()
    base.addClass(style.base)

    const top = Div()
    top.addClass(style.bar, style.top)

    const bottom = Div()
    bottom.addClass(style.bar, style.bottom)

    base.append(top, bottom)

    return base
}
